import {faPlus} from "@fortawesome/free-solid-svg-icons";
import BookingChannelDatalist from "components/entities/accommodation/channel/BookingChannelDatalist";
import {Roles} from "utilities/app-utilities";
import Page, {PageActionsType} from "../../../components/common/page/Page";
import useAppContext from "../../../utilities/hooks/useAppContext";
import { AppRoutes } from "config/router";

const BookingChannelDatalistPage = () => {
    const context = useAppContext();
    const name = "booking-channel-settings-page"
    const pageActions: PageActionsType = [
        {
            name: 'add',
            title: 'button.add',
            icon: faPlus,
            hide: !context.userHasRole(Roles.ADMIN),
            link: AppRoutes.ACCOMMODATION_CHANNELS_FORM
        }
    ];

    return (
        <Page wFull title="pages.accommodation.channel.list" actions={pageActions}>
            <BookingChannelDatalist name={name}/>
        </Page>
    );
}

export default BookingChannelDatalistPage;
